import UserView from './UserView';

export default UserView;
